export default {"src":"/_next/static/media/walletconnect.85b5912a.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};